import { HttpClient } from "../HttpClient";
/**
 * * Post Deductions
 */
export const PostDeductions = async (deductionData) => {
	try {
		const { data } = await HttpClient.post("api/assetRevenueDeductions", { ...deductionData });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
